import { Grid } from "@material-ui/core";
import { ViewEditMode } from "@saleor/changeOrderExport/views/ViewEditOrder/types";
import MyTypography from "@saleor/components/MyTypography";
import TextAreaField from "@saleor/components/TextAreaField";
import { ContractChangeOrderDomesticQuery } from "@saleor/graphql";
import useAppState from "@saleor/hooks/useAppState";
import { makeStyles } from "@saleor/macaw-ui";
import classNames from "classnames";
import { FormikProps } from "formik";
import React from "react";
import { useIntl } from "react-intl";

interface AdditionalTabProps {
  formik: FormikProps<any>;
  dataOrder: ContractChangeOrderDomesticQuery["changeOrder"];
  internalCommentsToLogistic: string;
  internalCommentsToWarehouse: string;
  externalCommentsToCustomer: string;
  productInformation: string;
}

const useStyles = makeStyles(
  theme => ({
    boxBackground: {
      borderRadius: 4,
      background: theme.palette.background.default,
      padding: "8px 16px",
      marginTop: 5,
      minHeight: 40
    },
    boxMinHeight: {
      minHeight: 100
    },
    boxTextArea: {
      whiteSpace: "pre-line"
    },
    routeSearch: {
      display: "flex",
      alignItems: "center",
      gap: 10
    },
    routerInput: {},
    routerBtn: {
      order: 1,
      height: 38
    },
    errorText: {
      color: theme.palette.error.light
    }
  }),
  { name: "AdditionalTab" }
);

const AdditionalTab: React.FC<AdditionalTabProps> = props => {
  const {
    formik,
    internalCommentsToLogistic,
    internalCommentsToWarehouse,
    productInformation,
    externalCommentsToCustomer
  } = props;
  const classes = useStyles();
  const intl = useIntl();
  const [{ viewEditMode }] = useAppState();
  return (
    <>
      <Grid container spacing={6} data-testid="additionalTabDetail">
        <Grid item xs={12} md={6}>
          <MyTypography variant={"subtitle3"}>
            {intl.formatMessage({
              defaultMessage: "Internal Comments to Warehouse"
            })}
          </MyTypography>
          {viewEditMode === ViewEditMode.VIEW ? (
            <MyTypography
              variant={"body3"}
              className={classNames(
                classes.boxBackground,
                classes.boxMinHeight,
                classes.boxTextArea
              )}
              data-testid="internalCommentsToWarehouse-text"
            >
              {internalCommentsToWarehouse}
            </MyTypography>
          ) : (
            <TextAreaField
              maxLength={1320}
              lineLimit={132}
              name={"internalCommentsToWarehouse"}
              id="internalCommentsToWarehouse"
              onChange={formik.handleChange}
              rowsMin={3}
              value={formik.values.internalCommentsToWarehouse}
              data-testid="internalCommentsToWarehouse-input"
            />
          )}
        </Grid>
        <Grid item xs={12} md={6}>
          <MyTypography variant={"subtitle3"}>
            {intl.formatMessage({
              defaultMessage: "Internal Comments to Logistic"
            })}
          </MyTypography>
          {viewEditMode === ViewEditMode.VIEW ? (
            <MyTypography
              variant={"body3"}
              className={classNames(
                classes.boxBackground,
                classes.boxMinHeight,
                classes.boxTextArea
              )}
              data-testid="internalCommentsToLogistic-text"
            >
              {internalCommentsToLogistic}
            </MyTypography>
          ) : (
            <TextAreaField
              maxLength={1320}
              lineLimit={132}
              name={"internalCommentsToLogistic"}
              id="internalCommentsToLogistic"
              onChange={formik.handleChange}
              rowsMin={3}
              value={formik.values.internalCommentsToLogistic}
              data-testid="internalCommentsToLogistic-input"
            />
          )}
        </Grid>
        <Grid item xs={12} md={6}>
          <MyTypography variant={"subtitle3"}>
            {intl.formatMessage({
              defaultMessage: "External Comments to Customer"
            })}
          </MyTypography>
          {viewEditMode === ViewEditMode.VIEW ? (
            <MyTypography
              variant={"body3"}
              className={classNames(
                classes.boxBackground,
                classes.boxMinHeight,
                classes.boxTextArea
              )}
              data-testid="externalCommentsToCustomer-text"
            >
              {externalCommentsToCustomer}
            </MyTypography>
          ) : (
            <TextAreaField
              maxLength={1320}
              lineLimit={132}
              name={"externalCommentsToCustomer"}
              id="externalCommentsToCustomer"
              onChange={formik.handleChange}
              rowsMin={3}
              value={formik.values.externalCommentsToCustomer}
              data-testid="externalCommentsToCustomer-input"
            />
          )}
        </Grid>
        <Grid item xs={12} md={6}>
          <MyTypography variant={"subtitle3"}>
            {intl.formatMessage({ defaultMessage: "Production information" })}
          </MyTypography>
          {viewEditMode === ViewEditMode.VIEW ? (
            <MyTypography
              variant={"body3"}
              className={classNames(
                classes.boxBackground,
                classes.boxMinHeight,
                classes.boxTextArea
              )}
              data-testid="productInformation-text"
            >
              {productInformation}
            </MyTypography>
          ) : (
            <TextAreaField
              maxLength={1320}
              lineLimit={132}
              name={"productInformation"}
              id="productInformation"
              onChange={formik.handleChange}
              rowsMin={3}
              value={formik.values.productInformation}
              data-testid="productInformation-input"
            />
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default AdditionalTab;
